/* Sequential Racing: sticky Add to cart bar (Claude, Oct 2026).
   Restyles the theme's own #sticky-cta: full-width bar that only appears once the main Add to cart button
   has scrolled off screen, and hides again over the footer (plain scroll check, so it also works where IntersectionObserver is throttled). The theme still handles the button itself. */
(function () {
  function init() {
    var bar = document.getElementById('sticky-cta');
    if (!bar || bar.getAttribute('data-srbb')) return;
    bar.setAttribute('data-srbb', '1');
    var main = document.querySelector('.product-form__submit[id^="ProductSubmitButton"]');
    if (!main) { bar.style.display = 'none'; return; }
    bar.classList.add('srbb');

    var inner = document.createElement('div');
    inner.className = 'srbb__in';
    var img = document.querySelector('.product__media img, media-gallery img');
    if (img && (img.currentSrc || img.src)) {
      var t = document.createElement('img');
      t.className = 'srbb__img';
      t.alt = '';
      t.width = 96; t.height = 96;
      t.src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=120');
      inner.appendChild(t);
    }
    while (bar.firstChild) inner.appendChild(bar.firstChild);
    bar.appendChild(inner);

    var info = bar.querySelector('.sticky-cta__info');
    var vline = document.createElement('span');
    vline.className = 'srbb__v';
    var strong = info && info.querySelector('strong');
    if (strong) strong.insertAdjacentElement('afterend', vline);

    function variantText() {
      var parts = [];
      document.querySelectorAll('variant-selects select').forEach(function (s) {
        var o = s.options[s.selectedIndex];
        if (o) parts.push(o.textContent.trim());
      });
      document.querySelectorAll('variant-selects fieldset').forEach(function (f) {
        var c = f.querySelector('input:checked');
        if (c) parts.push(c.value);
      });
      vline.textContent = parts.join(', ');
      vline.hidden = !parts.length;
    }
    variantText();
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(variantText, 0); });

    var past = false, foot = false;
    function paint() {
      var on = past && !foot;
      bar.classList.toggle('is-on', on);
      if ('inert' in bar) bar.inert = !on;
    }
    var footer = document.querySelector('.section-footer, footer, [id*="__footer"]'), tmr = 0;
    function check() {
      tmr = 0;
      past = main.getBoundingClientRect().bottom < 0;
      foot = !!footer && footer.getBoundingClientRect().top < window.innerHeight;
      paint();
    }
    function soon() { if (!tmr) tmr = setTimeout(check, 60); }
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
